export default "__VITE_ASSET__e140da82__$_?component__"